<template>
  <div class="row">
    <div v-if="index > 0" class="col-12">
      <hr class="my-2" />
    </div>
    <div class="col-12 col-sm-9">
      <div class="item-name">
        <span class="title">{{ title }}</span>
        <span class="subtitle">({{ subtitle }})</span>
      </div>
      <div class="user-name">
        <span>{{ item.user.name }}</span>
        <span v-if="item.user.hvac_id"
          >&nbsp;(ID: {{ item.user.hvac_id }})</span
        >
      </div>
    </div>
    <div class="col-12 col-sm-3 text-right">
      <template v-if="!!item.series_discount">
        <span class="discount">{{ item.cost | cost }}</span>
        <span class="cost">{{
          (item.cost - item.series_discount) | cost
        }}</span>
      </template>
      <template v-else>
        {{ item.cost | cost }}
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: { type: Object, required: true },
    index: { type: Number, required: true },
  },
  computed: {
    isCourse() {
      return !!this.item.item_type && this.item.item_type === "course";
    },
    isLearningPath() {
      return !!this.item.item_type && this.item.item_type === "learning_path";
    },
    subtitle() {
      if (this.isLearningPath) {
        return "Learning Path";
      } else {
        return "Online Course";
      }
    },
    title() {
      if (this.isLearningPath) {
        return this.item.learning_path.name;
      } else {
        return this.item.enrollable.name;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.item-name {
  font-size: 14px;
  .title {
    font-weight: bold;
  }
  .subtitle {
    color: #888888;
  }
}
.user-name {
  font-size: 14px;
}
.discount {
  color: #888888;
  text-decoration: line-through;
}
</style>